import { Preferences } from '@capacitor/preferences';

// Keys for storage
const KEYS = {
  USER_TYPE_PREFERENCE: 'pacarion_user_type_preference', // 'homeowner' or 'agent'
  CLIENT_ID: 'pacarion_client_id',
  HOMEOWNER_TOKEN: 'pacarion_homeowner_token',
  PUSH_TOKEN: 'pacarion_push_token',
  PUSH_DEVICE_ID: 'pacarion_push_device_id',
};

// Store user type preference (homeowner or agent)
export const setUserTypePreference = async (userType) => {
  try {
    await Preferences.set({
      key: KEYS.USER_TYPE_PREFERENCE,
      value: userType
    });
  } catch (error) {
    console.error('Error saving user type preference:', error);
  }
};

// Get user type preference
export const getUserTypePreference = async () => {
  try {
    const { value } = await Preferences.get({ key: KEYS.USER_TYPE_PREFERENCE });
    return value; // Returns 'homeowner', 'agent', or null
  } catch (error) {
    console.error('Error getting user type preference:', error);
    return null;
  }
};

// Clear user type preference (for logout/reset)
export const clearUserTypePreference = async () => {
  try {
    await Preferences.remove({ key: KEYS.USER_TYPE_PREFERENCE });
  } catch (error) {
    console.error('Error clearing user type preference:', error);
  }
};

// Store client ID (for homeowners)
export const setClientId = async (clientId) => {
  try {
    await Preferences.set({
      key: KEYS.CLIENT_ID,
      value: clientId
    });
  } catch (error) {
    console.error('Error saving client ID:', error);
  }
};

// Get client ID
export const getClientId = async () => {
  try {
    const { value } = await Preferences.get({ key: KEYS.CLIENT_ID });
    return value;
  } catch (error) {
    console.error('Error getting client ID:', error);
    return null;
  }
};

export const setHomeownerToken = async (token) => {
  try {
    await Preferences.set({ key: KEYS.HOMEOWNER_TOKEN, value: token });
  } catch (error) {
    console.error('Error saving homeowner token:', error);
  }
};

export const getHomeownerToken = async () => {
  try {
    const { value } = await Preferences.get({ key: KEYS.HOMEOWNER_TOKEN });
    return value;
  } catch (error) {
    console.error('Error getting homeowner token:', error);
    return null;
  }
};

export const setStoredPushToken = async (token) => {
  try {
    if (!token) return;
    await Preferences.set({ key: KEYS.PUSH_TOKEN, value: token });
  } catch (error) {
    console.error('Error saving push token:', error);
  }
};

export const getStoredPushToken = async () => {
  try {
    const { value } = await Preferences.get({ key: KEYS.PUSH_TOKEN });
    return value || null;
  } catch (error) {
    console.error('Error getting push token:', error);
    return null;
  }
};

function newPushDeviceId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `install-${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}`;
}

/** One id per install. Logout uses it when the push token is not in memory. */
export const ensurePushDeviceId = async () => {
  try {
    const existing = await Preferences.get({ key: KEYS.PUSH_DEVICE_ID });
    if (existing && existing.value) return existing.value;
    const created = newPushDeviceId();
    await Preferences.set({ key: KEYS.PUSH_DEVICE_ID, value: created });
    return created;
  } catch (error) {
    console.error('Error reading push device id:', error);
    return '';
  }
};

export const clearHomeownerToken = async () => {
  try {
    await Preferences.remove({ key: KEYS.HOMEOWNER_TOKEN });
  } catch (error) {
    console.error('Error clearing homeowner token:', error);
  }
};

// Clear client ID
export const clearClientId = async () => {
  try {
    await Preferences.remove({ key: KEYS.CLIENT_ID });
  } catch (error) {
    console.error('Error clearing client ID:', error);
  }
};
